import React, { useEffect, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import {
  Badge,
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import "../Setting/settingPage.css";
import { ThemeColor } from "../../component/theme/color";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOrganizationAction,
  GetSettingCountAction,
} from "../../Redux/action/SettingAction";
import { GetMicrosoftAccessTokenCodeService, GetMicrosoftAuthCodeService, DisconnectMicrosoftService } from "../../Redux/service/MailService";
import { GetDefaultIntakeService } from "../../Redux/service/SettingService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VideoModal from "../../component/videoplayer/VideoModal";

const SettingsDashboard = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [searchParams] = useSearchParams();
  const [Organizationlist, setOrganizationlist] = useState([]);

  const code = searchParams?.get("code");

  const [defaultIntake, setDefaultIntake] = useState();

  const GetDefaultIntake = async () => {
    GetDefaultIntakeService()
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          setDefaultIntake(res.data?.defaultIntake?.[0]?.intake);
        }
      })
      .catch((err) => {
        console.log("error getting default intake=>", err);
      });
  };

  useEffect(() => {
    GetDefaultIntake();
  }, []);

  useEffect(() => {
    const fetchAccessToken = async () => {
      if (!window.sessionStorage.getItem("ms_auth") && code != null) {
        try {
          const res = await GetMicrosoftAccessTokenCodeService(code);
          if (res.status === 200) {
            //(res, "res from get access token");
            window.sessionStorage.setItem("ms_auth", res.data.accessToken);
          }
        } catch (err) {
          //("ms auth token error", err);
        }
      }
    };

    fetchAccessToken();
  }, [code]);

  const handleConnectMicrosoft = async () => {
    try {
      const res = await GetMicrosoftAuthCodeService();
      if (res.status === 200 && res.data?.AuthorizationURL) {
        window.location.href = res.data.AuthorizationURL;
      } else {
        dispatch(
          showSnackbar("Unable to start Microsoft sign in. Try again.", "error")
        );
      }
    } catch (err) {
      dispatch(
        showSnackbar("Unable to start Microsoft sign in. Try again.", "error")
      );
    }
  };

  const handleDisconnectMicrosoft = async () => {
    try {
      const res = await DisconnectMicrosoftService();
      if (res.status === 200) {
        window.sessionStorage.removeItem("ms_auth");
        window.sessionStorage.removeItem("ms_auth_skipped");
        dispatch(showSnackbar("Microsoft account disconnected successfully", "success"));
        navigate(0); // reload page to update state
      } else {
        dispatch(showSnackbar("Unable to disconnect. Try again.", "error"));
      }
    } catch (err) {
      dispatch(showSnackbar("Unable to disconnect. Try again.", "error"));
    }
  };

  const [settingCountData, setSettingCountData] = useState([]);

  useEffect(() => {
    dispatch(GetSettingCountAction());
  }, []);

  const SettingCountState = useSelector(
    (state) => state.setting?.settingCount?.data?.data
  );

  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data
  );

  console.log(OrganizationlistState);

  useEffect(() => {
    setOrganizationlist(
      OrganizationlistState?.organizations?.map(({ _id, ...rest }) => ({
        id: _id,
        ...rest,
      }))
    );
  }, [OrganizationlistState]);

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetOrganizationAction(data));
  }, []);
  //(SettingCountState);

  useEffect(() => {
    setSettingCountData(SettingCountState);
  }, [SettingCountState]);

  return (
    <div>
      <Typography
        fontFamily={FontFamily.Poppins}
        fontWeight={fontWeight.W600}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          fontSize: { xs: fontSize.h3.large, sm: fontSize.h2.small },
        }}
      >
        Settings{" "}
        <Tooltip title="Training Video">
          <IconButton onClick={handleOpen} size="small">
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Typography>

      <Grid
        container
        spacing={{ xs: 2, sm: 2.5, md: 3 }}
        pt={{ xs: 2.5, md: 4 }}
        alignItems="stretch"
      >
        {((window.sessionStorage.getItem("user_role_type") === "agent" &&
          (window.sessionStorage.getItem("role") === "admin" ||
            window.sessionStorage.getItem("role") === "agent_accountant")) ||
          window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/org.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  // position: "absolute",
                  // top: 0,
                  // left: 0,
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)", // white overlay

                  // backgroundColor: "rgba(255, 255, 255, 0.3)", // white overlay
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%", minHeight: "190px",
                }}
              >
                <div className="setting-card-left h-100">
                  {window.sessionStorage.getItem("user_role_type") !==
                  "agent" ? (
                    // <Badge
                    //   badgeContent={4} // You can replace this with your actual count or leave empty for dot
                    //   color="error"
                    //   sx={{
                    //     "& .MuiBadge-badge": {
                    //       fontSize: "0.7rem",
                    //       // height: 18,
                    //       // minWidth: 18,
                    //     },
                    //   }}
                    // >
                    //   <Typography
                    //     fontFamily={FontFamily.Ubuntu}
                    //     fontSize={fontSize.h2.medium}
                    //     fontWeight={fontWeight.W500}
                    //   >
                    //     Organizations
                    //   </Typography>
                    // </Badge>
                    <Typography
                      fontFamily={FontFamily.Ubuntu}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      Organization
                    </Typography>
                  ) : (
                    <Typography
                      fontFamily={FontFamily.Ubuntu}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      Organization
                    </Typography>
                  )}

                  <div className="setting-per1" style={{}}>
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                      color={ThemeColor.GREY}
                    >
                      {settingCountData?.organizationCount || 0}
                    </Typography>
                  </div>

                  <div className="setting-card-link-sec w-100">
                    {(window.sessionStorage.getItem("user_role_type") ===
                      "admin" ||
                      !window.sessionStorage.getItem("user_role_type") ===
                        "user") && (
                      // <Typography
                      //   fontFamily={FontFamily.Ubuntu}
                      //   fontSize={fontSize.h4.medium}
                      //   fontWeight={fontWeight.W500}
                      //   color={ThemeColor.RED}
                      //   className="underline-hover"
                      //   onClick={() => {
                      //     navigate("/CAE/CreateOrganization");
                      //   }}
                      // >
                      //   Add New
                      // </Typography>
                      <div className="pe-2">
                        <Button
                          onClick={() => {
                            navigate("/CAE/CreateOrganization");
                          }}
                          variant="contained"
                          sx={{
                            backgroundColor: "#d9534f", // Bootstrap-like red
                            "&:hover": {
                              backgroundColor: "#c9302c",
                            },
                            textTransform: "none",
                            borderRadius: "8px",
                          }}
                        >
                          Add New
                        </Button>
                      </div>
                    )}

                    <Button
                      variant="outlined"
                      // onClick={() => {
                      //   navigate("/CAE/CreateOrganization");
                      // }}
                      onClick={() => {
                        if (
                          window.sessionStorage.getItem("user_role_type") ===
                          "agent"
                        ) {
                          navigate(
                            `/CAE/MyOrganization/${Organizationlist?.[0]?.id}`
                          );
                        } else navigate("/CAE/OrganizationList");
                      }}
                      sx={{
                        color: "#0275d8",
                        borderColor: "#0275d8",
                        "&:hover": {
                          backgroundColor: "#e6f2fb",
                          borderColor: "#0275d8",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "1px 15px",
                        fontWeight: 500,
                      }}
                    >
                      {/* View All */}
                      {window.sessionStorage.getItem("user_role_type") ===
                      "agent"
                        ? // ||
                          // window.sessionStorage.getItem("role") ===
                          // "admin"
                          "My Commission"
                        : "View All"}
                    </Button>

                    {/* <Typography
                      fontFamily={FontFamily.Ubuntu}
                      fontSize={fontSize.h4.medium}
                      fontWeight={fontWeight.W500}
                      color={ThemeColor.RED}
                      className="px-3 underline-hover"
                      onClick={() => {
                        if (
                          window.sessionStorage.getItem("user_role_type") ===
                          "agent"
                        ) {
                          navigate(
                            `/CAE/MyOrganization/${Organizationlist?.[0]?.id}`
                          );
                        } else navigate("/CAE/OrganizationList");
                      }}
                    >
                      {window.sessionStorage.getItem("user_role_type") ===
                      "agent"
                        ? // ||
                          // window.sessionStorage.getItem("role") ===
                          // "admin"
                          "My Commission"
                        : "View All"}
                    </Typography> */}
                  </div>
                </div>
                {window.sessionStorage.getItem("user_role_type") !== "agent" ? (
                  <div className="setting-card-right h-100">
                    {/* <div className="w-100 d-flex justify-content-center align-item-center h-100">
                      <div
                        className="setting-per"
                        style={{ background: "white" }}
                      >
                        <Typography
                          fontFamily={FontFamily.Nunito}
                          fontSize={fontSize.h2.medium}
                          fontWeight={fontWeight.W500}
                        >
                          {settingCountData?.organizationCount || 0}
                        </Typography>
                      </div>
                    </div> */}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Box>
          </Grid>
        )}
        <Grid item xs={12} sm={6} lg={4}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundImage: "url('/assest/univer1.png')",
              backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
              backgroundPosition: "right center",
              backgroundRepeat: "no-repeat",
                borderRadius: "18px",
              borderRadius: 20,
            }}
          >
            <div
              className="setting-card w-100"
              style={{
                height: "100%", minHeight: "190px",
                // position: "absolute",
                // top: 0,
                // left: 0,
                background:
                  "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)", // white overlay
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
              }}
            >
              <div className="setting-card-left h-100">
                <Typography
                  fontFamily={FontFamily.Ubuntu}
                  fontSize={fontSize.h2.medium}
                  fontWeight={fontWeight.W500}
                >
                  Universities
                </Typography>
                <div
                  className="setting-per1"
                  style={{ background: "transparent" }}
                >
                  <Typography
                    fontFamily={FontFamily.Nunito}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                    color={ThemeColor.GREY}
                  >
                    {settingCountData?.universityCount || 0}
                  </Typography>
                </div>
                <div className="setting-card-link-sec w-100">
                  {(!window.sessionStorage.getItem("user_role_type") ===
                    "agent" ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "admin" ||
                    !window.sessionStorage.getItem("user_role_type") ===
                      "user") && (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#d9534f", // Bootstrap-like red
                        "&:hover": {
                          backgroundColor: "#c9302c",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        navigate("/CAE/CreateUniversity");
                      }}
                    >
                      Add New
                    </Button>
                  )}

                  <div className="ps-2">
                    <Button
                      variant="outlined"
                      sx={{
                        color: "#0275d8",
                        borderColor: "#0275d8",
                        "&:hover": {
                          backgroundColor: "#e6f2fb",
                          borderColor: "#0275d8",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                        // padding: "1px 15px",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        navigate("/CAE/Universitylist");
                      }}
                    >
                      {" "}
                      View All
                    </Button>
                  </div>
                </div>
              </div>
              <div className="setting-card-right h-100">
                {/* <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div
                    className="setting-per1"
                    style={{ background: "transparent" }}
                  >
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.universityCount || 0}
                    </Typography>
                  </div>
                </div> */}
              </div>
            </div>
          </Box>
        </Grid>
        {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
          window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/cae_user1.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    CAE Users
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    {(!window.sessionStorage.getItem("user_role_type") ===
                      "agent" ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "admin" ||
                      !window.sessionStorage.getItem("user_role_type") ===
                        "user") && (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#d9534f", // Bootstrap-like red
                          "&:hover": {
                            backgroundColor: "#c9302c",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          navigate("/CAE/AddUser");
                        }}
                      >
                        Add New
                      </Button>
                    )}
                    <div className="ps-2">
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#0275d8",
                          borderColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#e6f2fb",
                            borderColor: "#0275d8",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                          // padding: "1px 15px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          navigate("/CAE/UserList");
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                </div>
                {/* <div className="setting-card-right">
                <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div className="setting-per">
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.caeUserCount || 0}
                    </Typography>
                  </div>
                </div>
              </div> */}
              </div>
            </Box>
          </Grid>
        )}
        {(!(
          window.sessionStorage.getItem("user_role_type") === "agent" &&
          (window.sessionStorage.getItem("role") === "agent_counsellor" ||
            window.sessionStorage.getItem("role") === "agent_accountant")
        ) ||
          window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/agent1.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    {window.sessionStorage.getItem("user_role_type") === "agent"
                      ? "Members"
                      : "Agent-user"}
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#d9534f", // Bootstrap-like red
                        "&:hover": {
                          backgroundColor: "#c9302c",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        navigate("/CAE/AddAgent");
                      }}
                    >
                      Add New
                    </Button>
                    <div className="ps-2">
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#0275d8",
                          borderColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#e6f2fb",
                            borderColor: "#0275d8",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                          // padding: "1px 15px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          navigate("/CAE/AgentList");
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                </div>
                {/* <div className="setting-card-right">
                <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div className="setting-per">
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.agentCount || 0}
                    </Typography>
                  </div>
                </div>
              </div> */}
              </div>
            </Box>
          </Grid>
        )}
        {
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/program1.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    Program List
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    {(!(
                      window.sessionStorage.getItem("user_role_type") ===
                        "agent" &&
                      (window.sessionStorage.getItem("role") ===
                        "agent_counsellor" ||
                        window.sessionStorage.getItem("role") === "admin" ||
                        window.sessionStorage.getItem("role") ===
                          "application_supervisor")
                    ) ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "admin" ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "user") && (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#d9534f", // Bootstrap-like red
                          "&:hover": {
                            backgroundColor: "#c9302c",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          navigate("/CAE/AddProgram");
                        }}
                      >
                        Add New
                      </Button>
                    )}
                    <div className="ps-2">
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#0275d8",
                          borderColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#e6f2fb",
                            borderColor: "#0275d8",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                          // padding: "1px 15px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          navigate("/CAE/Programlist");
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                </div>
                {/* <div className="setting-card-right">
                <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div className="setting-per">
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.programCount || 0}
                    </Typography>
                  </div>
                </div>
              </div> */}
              </div>
            </Box>
          </Grid>
        }
        <Grid item xs={12} sm={6} lg={4}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundImage: "url('/assest/catalogue1.png')",
              backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
              backgroundPosition: "right center",
              backgroundRepeat: "no-repeat",
                borderRadius: "18px",
              // borderRadius: 20,
            }}
          >
            <div
              className="setting-card w-100"
              style={{
                height: "100%", minHeight: "190px",
                background:
                  "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
              }}
            >
              <div className="setting-card-left h-100">
                <Typography
                  fontFamily={FontFamily.Ubuntu}
                  fontSize={fontSize.h2.medium}
                  fontWeight={fontWeight.W500}
                >
                  Catalog / Brochure
                </Typography>
                <div className="setting-card-link-sec w-100">
                  {(!window.sessionStorage.getItem("user_role_type") ===
                    "agent" ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "admin" ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "user") && (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#d9534f", // Bootstrap-like red
                        "&:hover": {
                          backgroundColor: "#c9302c",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        navigate("/CAE/AddCatalogueBrochure");
                      }}
                    >
                      Add New
                    </Button>
                  )}
                  <div className="ps-2">
                    <Button
                      variant="outlined"
                      sx={{
                        color: "#0275d8",
                        borderColor: "#0275d8",
                        "&:hover": {
                          backgroundColor: "#e6f2fb",
                          borderColor: "#0275d8",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                        // padding: "1px 15px",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        navigate("/CAE/CatalogueBrochureList");
                      }}
                    >
                      View All
                    </Button>
                  </div>
                </div>
              </div>
              {/* <div className="setting-card-right">
              <div className="w-100 d-flex justify-content-center align-item-center h-100">
                <div className="setting-per">
                  <Typography
                    fontFamily={FontFamily.Nunito}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    {settingCountData?.catalogueBrochureCount || 0}
                  </Typography>
                </div>
              </div>
            </div> */}
            </div>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundImage: "url('/assest/process.png')",
              backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
              backgroundPosition: "right center",
              backgroundRepeat: "no-repeat",
                borderRadius: "18px",
              // borderRadius: 20,
            }}
          >
            <div
              className="setting-card w-100"
              style={{
                height: "100%", minHeight: "190px",
                background:
                  "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
              }}
            >
              <div className="setting-card-left h-100">
                <Typography
                  fontFamily={FontFamily.Ubuntu}
                  fontSize={fontSize.h2.medium}
                  fontWeight={fontWeight.W500}
                >
                  Process Sheet
                </Typography>
                <div className="setting-card-link-sec w-100">
                  {(!window.sessionStorage.getItem("user_role_type") ===
                    "agent" ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "admin" ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "user") && (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#d9534f", // Bootstrap-like red
                        "&:hover": {
                          backgroundColor: "#c9302c",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        navigate("/CAE/AddProcessSheet");
                      }}
                    >
                      Add New
                    </Button>
                  )}
                  <div className="ps-2">
                    <Button
                      variant="outlined"
                      sx={{
                        color: "#0275d8",
                        borderColor: "#0275d8",
                        "&:hover": {
                          backgroundColor: "#e6f2fb",
                          borderColor: "#0275d8",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                        // padding: "1px 15px",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        navigate("/CAE/Processlist");
                      }}
                    >
                      View All
                    </Button>
                  </div>
                </div>
              </div>
              {/* <div className="setting-card-right">
              <div className="w-100 d-flex justify-content-center align-item-center h-100">
                <div className="setting-per">
                  <Typography
                    fontFamily={FontFamily.Nunito}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    {settingCountData?.processSheetCount || 0}
                  </Typography>
                </div>
              </div>
            </div> */}
            </div>
          </Box>
        </Grid>
        {window.sessionStorage.getItem("user_role_type") === "admin" && (
          //  ||
          //   window.sessionStorage.getItem("user_role_type") === "user"
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/default_intak2.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    Default Intake
                  </Typography>
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h3.medium}
                    fontWeight={fontWeight.W400}
                    color={ThemeColor.GREY}
                  >
                    {defaultIntake}
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    {
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#d9534f", // Bootstrap-like red
                          "&:hover": {
                            backgroundColor: "#c9302c",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          navigate("/CAE/AddDefaultIntake");
                        }}
                      >
                        Add New
                      </Button>
                    }
                  </div>
                </div>
                {/* <div className="setting-card-right">
                <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div className="setting-per">
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.processSheetCount}
                    </Typography>
                  </div>
                </div>
              </div> */}
              </div>
            </Box>
          </Grid>
        )}
        {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
          window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/contry_list2.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    Country & State List
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    {(!(
                      window.sessionStorage.getItem("user_role_type") ===
                        "agent" &&
                      (window.sessionStorage.getItem("role") ===
                        "agent_counsellor" ||
                        window.sessionStorage.getItem("role") === "admin" ||
                        window.sessionStorage.getItem("role") ===
                          "application_supervisor")
                    ) ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "admin" ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "user") && (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#d9534f", // Bootstrap-like red
                          "&:hover": {
                            backgroundColor: "#c9302c",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          navigate("/CAE/AddCountry");
                        }}
                      >
                        Add New
                      </Button>
                    )}
                    <div className="ps-2">
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#0275d8",
                          borderColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#e6f2fb",
                            borderColor: "#0275d8",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                          // padding: "1px 15px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          navigate("/CAE/Countrylist");
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                </div>
                {/* <div className="setting-card-right">
                <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div className="setting-per">
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.countryCount || 0}
                    </Typography>
                  </div>
                </div>
              </div> */}
              </div>
            </Box>
          </Grid>
        )}
        {/* {
          <Grid item xs={12} sm={6} lg={4}>
            <div className="setting-card w-100">
              <div className="setting-card-left h-100">
                <Typography
                  fontFamily={FontFamily.Ubuntu}
                  fontSize={fontSize.h3.medium}
                  fontWeight={fontWeight.W500}
                >
                  State List
                </Typography>
                <div className="setting-card-link-sec w-100">
                  {(!(
                    window.sessionStorage.getItem("user_role_type") ===
                      "agent" &&
                    (window.sessionStorage.getItem("role") ===
                      "agent_counsellor" ||
                      window.sessionStorage.getItem("role") === "admin" ||
                      window.sessionStorage.getItem("role") ===
                        "application_supervisor")
                  ) ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "admin" ||
                    window.sessionStorage.getItem("user_role_type") ===
                      "user") && (
                    <Typography
                      fontFamily={FontFamily.Ubuntu}
                      fontSize={fontSize.h4.medium}
                      fontWeight={fontWeight.W500}
                      color={ThemeColor.RED}
                      className="underline-hover"
                      onClick={() => {
                        navigate("/CAE/AddState");
                      }}
                    >
                      Add New
                    </Typography>
                  )}

                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h4.medium}
                    fontWeight={fontWeight.W500}
                    color={ThemeColor.RED}
                    className="px-3 underline-hover"
                    onClick={() => {
                      navigate("/CAE/Statelist");
                    }}
                  >
                    View All
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
        } */}
        {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
          window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/contract_type2.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    Contract Type
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    {(!(
                      window.sessionStorage.getItem("user_role_type") ===
                        "agent" &&
                      (window.sessionStorage.getItem("role") ===
                        "agent_counsellor" ||
                        window.sessionStorage.getItem("role") === "admin" ||
                        window.sessionStorage.getItem("role") ===
                          "application_supervisor")
                    ) ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "admin" ||
                      window.sessionStorage.getItem("user_role_type") ===
                        "user") && (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#d9534f", // Bootstrap-like red
                          "&:hover": {
                            backgroundColor: "#c9302c",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          navigate("/CAE/AddContract");
                        }}
                      >
                        Add New
                      </Button>
                    )}
                    <div className="ps-2">
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#0275d8",
                          borderColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#e6f2fb",
                            borderColor: "#0275d8",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                          // padding: "1px 15px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          navigate("/CAE/Contractlist");
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                </div>
                {/* <div className="setting-card-right">
                <div className="w-100 d-flex justify-content-center align-item-center h-100">
                  <div className="setting-per">
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      {settingCountData?.contractTypeCount || 0}
                    </Typography>
                  </div>
                </div>
              </div> */}
              </div>
            </Box>
          </Grid>
        )}
        {(window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/degress2.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
                // borderRadius: 20,
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100">
                  <Typography
                    fontFamily={FontFamily.Ubuntu}
                    fontSize={fontSize.h2.medium}
                    fontWeight={fontWeight.W500}
                  >
                    Degree
                  </Typography>
                  <div className="setting-card-link-sec w-100">
                    {/* {(!(
          window.sessionStorage.getItem("user_role_type") === "agent" &&
          (window.sessionStorage.getItem("role") ===
            "agent_counsellor" ||
            window.sessionStorage.getItem("role") === "admin" ||
            window.sessionStorage.getItem("role") ===
              "application_supervisor")
        ) ||
          window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") ===
            "user") &&  */}
                    {/* ( */}
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#d9534f", // Bootstrap-like red
                        "&:hover": {
                          backgroundColor: "#c9302c",
                        },
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        navigate("/CAE/AddDegree");
                      }}
                    >
                      Add New
                    </Button>
                    {/* )} */}
                    <div className="ps-2">
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#0275d8",
                          borderColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#e6f2fb",
                            borderColor: "#0275d8",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                          // padding: "1px 15px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          navigate("/CAE/Degreelist");
                        }}
                      >
                        View All
                      </Button>
                    </div>
                  </div>
                </div>
                {/* <div className="setting-card-right">
        <div className="w-100 d-flex justify-content-center align-item-center h-100">
          <div className="setting-per">
            <Typography
              fontFamily={FontFamily.Nunito}
              fontSize={fontSize.h2.medium}
              fontWeight={fontWeight.W500}
            >
              {settingCountData?.contractTypeCount || 0}
            </Typography>
          </div>
        </div>
      </div> */}
              </div>
            </Box>
          </Grid>
        )}
        {(window.sessionStorage.getItem("user_role_type") === "admin" ||
          window.sessionStorage.getItem("user_role_type") === "user") && (
          <Grid item xs={12} sm={6} lg={4}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: "url('/assest/microsoft.png')",
                backgroundSize: { xs: "auto 45%", sm: "auto 62%", md: "auto 72%" },
                backgroundPosition: "right center",
                backgroundRepeat: "no-repeat",
                borderRadius: "18px",
              }}
            >
              <div
                className="setting-card w-100"
                style={{
                  height: "100%", minHeight: "190px",
                  background:
                    "linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0.92) 52%, rgba(255,255,255,0.4) 100%)",
                }}
              >
                <div className="setting-card-left h-100" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                  <div>
                    <Typography
                      fontFamily={FontFamily.Ubuntu}
                      fontSize={fontSize.h2.medium}
                      fontWeight={fontWeight.W500}
                    >
                      Microsoft Account
                    </Typography>
                    <Typography
                      fontFamily={FontFamily.Nunito}
                      fontSize={fontSize.h3.small}
                      fontWeight={fontWeight.W500}
                      color={ThemeColor.GREY}
                      sx={{ pt: 1 }}
                    >
                      {window.sessionStorage.getItem("ms_auth")
                        ? "Connected to Office 365"
                        : "Not Connected"}
                    </Typography>
                  </div>
                  <div className="setting-card-link-sec w-100" style={{ pt: 2, display: "flex", gap: "10px" }}>
                    {window.sessionStorage.getItem("ms_auth") ? (
                      <>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#d9534f",
                            "&:hover": {
                              backgroundColor: "#c9302c",
                            },
                            textTransform: "none",
                            borderRadius: "8px",
                          }}
                          onClick={handleDisconnectMicrosoft}
                        >
                          Disconnect
                        </Button>
                        <Button
                          variant="outlined"
                          sx={{
                            color: "#0275d8",
                            borderColor: "#0275d8",
                            "&:hover": {
                              backgroundColor: "#e6f2fb",
                              borderColor: "#0275d8",
                            },
                            textTransform: "none",
                            borderRadius: "8px",
                          }}
                          onClick={handleConnectMicrosoft}
                        >
                          Change Account
                        </Button>
                      </>
                    ) : (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#0275d8",
                          "&:hover": {
                            backgroundColor: "#025aa5",
                          },
                          textTransform: "none",
                          borderRadius: "8px",
                        }}
                        onClick={handleConnectMicrosoft}
                      >
                        Connect
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Box>
          </Grid>
        )}
      </Grid>
      <VideoModal
        open={open}
        handleClose={handleClose}
        videoSrc="/assest/video/CRM TUTORIAL OVERVIEW.mp4" // Place video in public/videos/sample.mp4
      />
    </div>
  );
};

function Dashboard() {
  return <ResponsiveDrawer maincontent={<SettingsDashboard />} />;
}

export default Dashboard;
